import { InfoDocumentComponent } from "../InfoDocumentComponent";
import paymentContent from "./content";

export const PaymentInfo = () => <InfoDocumentComponent content={paymentContent} />;
